import { Temporal as mr, DateTimeFormat as Sr, toTemporalInstant as tm } from "./chunks/classApi.js";

import { createPropDescriptors as p } from "./chunks/internal.js";

Object.defineProperties(globalThis, p({
  Temporal: mr
})), Object.defineProperties(Intl, p({
  DateTimeFormat: Sr
})), Object.defineProperties(Date.prototype, p({
  toTemporalInstant: tm
}));
